module.exports = __webpack_public_path__ + "img/aftersalesLogo1.dd1d67ce.png";